import { useMemo } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { getPercentFunded } from '@arrived/common';
import { Offering } from '@arrived/models';

import { usePropertyStyles } from '../../Property';
import { PropertyMonetaryAvailabilityInfo } from '../PropertyMonetaryAvailabilityInfo';

interface PropertyListItemProgressBarProps {
  isLabelInBar?: boolean;
  isLabelVisible?: boolean;
  offering: Offering;
}

export const PropertyProgressBar = ({
  isLabelInBar,
  isLabelVisible = true,
  offering,
}: PropertyListItemProgressBarProps) => {
  const { barColor } = usePropertyStyles(offering);
  const LabelComponent = useMemo(() => {
    return (
      <Typography
        variant="body2.medium"
        display="block"
        px={1}
        sx={{
          position: offering.fundedPercentNoDebt < 50 ? 'relative' : 'absolute',
          right: 0,
          background: 'transparent',
          width: 'auto',
        }}
      >
        <PropertyMonetaryAvailabilityInfo offering={offering} />
      </Typography>
    );
  }, [offering]);
  return (
    <Stack
      width="100%"
      direction="row"
      alignItems="center"
      gap={1}
      sx={{ height: '15px', backgroundColor: ({ palette }) => palette.background.iceGray }}
    >
      <Box
        display="inline-flex"
        alignItems="center"
        justifyContent="right"
        pr={1}
        width={`${getPercentFunded(offering)}%`}
        height="100%"
        sx={{
          background: barColor,
          position: 'relative',
        }}
      ></Box>
      {isLabelVisible && isLabelInBar && LabelComponent}

      {isLabelVisible && !isLabelInBar && LabelComponent}
    </Stack>
  );
};
